/**
 * Actively removes cookies dropped by analytics/marketing tags when the
 * visitor rejects or withdraws consent (GDPR Art. 7(3) / ePrivacy).
 */
const TRACKING_PREFIXES = [
  "_ga",
  "_gid",
  "_gat",
  "_gcl",
  "hubspotutk",
  "__hs",
  "__hssc",
  "__hssrc",
  "__hstc",
  "messagesUtk",
  "bcookie",
  "bscookie",
  "li_",
  "lidc",
  "UserMatchHistory",
  "AnalyticsSyncHistory",
  "_fbp",
  "_fbc",
];

export function clearTrackingCookies() {
  if (typeof document === "undefined") return;
  const host = window.location.hostname;
  const domains = new Set<string>([host, `.${host}`]);
  const parts = host.split(".");
  if (parts.length > 2) domains.add(`.${parts.slice(-2).join(".")}`);

  for (const raw of document.cookie.split(";")) {
    const name = raw.split("=")[0]?.trim();
    if (!name) continue;
    if (!TRACKING_PREFIXES.some((p) => name === p || name.startsWith(p))) continue;
    for (const domain of domains) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
    }
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }
}
